/** import external dependencies */
import 'jquery';

// Import Slick
import 'slick-carousel/slick/slick';
import '@fancyapps/fancybox';

// Import Mask for forms
import 'jquery-mask-plugin';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import publicacoes from './routes/publicacoes';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  // Publicações
  publicacoes,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js